import api from './apiLibrary';

const API = {
    getMatchesOverview(params) {
        return api.get('api/admin/pass/shop-tickets', params);
    },
};

export default API;
